import {DynamicComponent} from '../types';

export const NextModule = Symbol('@backstage-components::next-module');
export type NextModule = typeof NextModule;

export interface Renderer {
  tryRender(definition: DynamicComponent): JSX.Element | NextModule;
}
